<sc-flex vertical fitHeight stretchContent class="no-field-space article-price-editor">
    <sc-dialog-title>
      <sc-dictionary-label dictionaryKey="erp.ui.article-price-editor.title"></sc-dictionary-label>
    </sc-dialog-title>

    <div>
        <form [formGroup]="formGroup">
            <sc-flex vertical stretchContent>
                <sc-padding>
                    <sc-flex >
                        <mat-form-field appearance="fill">
                            <mat-label>
                              <sc-dictionary-label dictionaryKey="erp.entity.price.valid-from"></sc-dictionary-label>
                            </mat-label>
                            <input matInput [matDatepicker]="picker1" formControlName="date_from" required="true" type="date-local">
                            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                            <mat-datepicker #picker1></mat-datepicker>
                        </mat-form-field>
                        <sc-content-spacer></sc-content-spacer>
                        <mat-form-field appearance="fill" class="date-field">
                            <mat-label>
                              <sc-dictionary-label dictionaryKey="erp.entity.price.valid-until"></sc-dictionary-label>
                            </mat-label>
                            <input matInput [matDatepicker]="picker2" formControlName="date_until" type="date-local">
                            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                            <mat-datepicker #picker2></mat-datepicker>
                        </mat-form-field>
                        <sc-content-spacer grow></sc-content-spacer>
                        <mat-form-field appearance="fill" *ngIf="mode == 'costs'">
                            <mat-label>
                              <sc-dictionary-label dictionaryKey="erp.entity.price.source"></sc-dictionary-label>
                            </mat-label>
                          <!--(selectionChange)="selectionChanged($event)"-->
                          <mat-select [required]="true" formControlName="source">
                            <mat-option *ngFor="let o of costsPriceSources" value="{{o}}">
                              {{o}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                        <sc-content-spacer *ngIf="mode == 'costs'"></sc-content-spacer>
                        <mat-form-field appearance="fill">
                            <mat-label>
                              <sc-dictionary-label dictionaryKey="erp.entity.price.referencedate"></sc-dictionary-label>
                            </mat-label>
                            <input matInput [matDatepicker]="picker3" formControlName="reference">
                            <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
                            <mat-datepicker #picker3></mat-datepicker>
                        </mat-form-field>
                    </sc-flex>
                </sc-padding>



                <sc-padding>

                    <mat-radio-group class="price-radio-group" *ngIf="allowBasicPriceSelectionOption == true" formControlName="useBasicPrice">
                        <sc-flex vertical stretchContent>
                            <mat-radio-button value="true">
                                <sc-flex >
                                    <sc-content-spacer></sc-content-spacer>
                                    <sc-dictionary-label dictionaryKey="erp.entity.price.use-basicprice"></sc-dictionary-label>
                                </sc-flex>
                            </mat-radio-button>
                            <mat-radio-button value="false">
                                <sc-flex >
                                    <sc-content-spacer></sc-content-spacer>
                                    <mat-form-field appearance="fill">
                                        <mat-label>
                                          <sc-dictionary-label dictionaryKey="erp.entity.price.price-net"></sc-dictionary-label>
                                        </mat-label>
                                        <span matSuffix>€</span>
                                        <input matInput numberInput [scale]="priceScale" formControlName="price_net" [required]="!useBasicPriceOptionSelected">
                                    </mat-form-field>

                                    <ng-container *ngIf="!hideVatPrices">
                                      <sc-content-spacer></sc-content-spacer>
                                      <mat-form-field appearance="fill">
                                          <mat-label>
                                            <sc-dictionary-label dictionaryKey="erp.entity.price.tax-rate"></sc-dictionary-label>
                                          </mat-label>
                                          <input matInput numberInput [scale]="0" formControlName="tax_rate">
                                          <span matSuffix>%</span>
                                      </mat-form-field>
                                        <sc-content-spacer></sc-content-spacer>
                                        <mat-form-field appearance="fill">
                                            <mat-label>
                                              <sc-dictionary-label dictionaryKey="erp.entity.price.price-vat"></sc-dictionary-label>
                                            </mat-label>
                                            <input matInput numberInput [scale]="priceScale" formControlName="price_vat">
                                            <span matSuffix>€</span>
                                        </mat-form-field>

                                    </ng-container>
                                </sc-flex>
                            </mat-radio-button>
                        </sc-flex>
                    </mat-radio-group>

                    <sc-flex *ngIf="allowBasicPriceSelectionOption == false">
                        <mat-form-field appearance="fill" class="number-field">
                            <mat-label>
                              <sc-dictionary-label dictionaryKey="erp.entity.price.price-net"></sc-dictionary-label>
                            </mat-label>
                            <input matInput numberInput [scale]="priceScale" formControlName="price_net" [required]="true">
                        </mat-form-field>
                        <ng-container *ngIf="!hideVatPrices">

                          <sc-content-spacer></sc-content-spacer>
                          <mat-form-field appearance="fill" class="number-field">
                              <mat-label>
                                <sc-dictionary-label dictionaryKey="erp.entity.price.tax-rate"></sc-dictionary-label>
                              </mat-label>
                              <input matInput numberInput [scale]="0" formControlName="tax_rate">
                          </mat-form-field>

                          <sc-content-spacer></sc-content-spacer>
                          <mat-form-field appearance="fill" class="number-field">
                              <mat-label>
                                <sc-dictionary-label dictionaryKey="erp.entity.price.price-vat"></sc-dictionary-label>
                              </mat-label>
                              <input matInput numberInput [scale]="priceScale" formControlName="price_vat">
                          </mat-form-field>
                        </ng-container>
                    </sc-flex>
                </sc-padding>

                <div class="costsPriceAttributes" *ngIf="mode == 'costs'">
                  <sc-padding>
                    <sc-flex stretchContent>
                    <ng-container *ngFor="let group of costsPriceAttributeGroups; let i = index" >
                      <sc-content-spacer *ngIf="i>0"></sc-content-spacer>
                      <sc-flex-fitting-content>
                        <sc-bordered-tile>
                          <sc-padding>
                            <app-attribute-group [formGroup]="formGroup" [attributeGroup]="group" [valuesMap]="price.valuesMap" [usage]="group.usage"></app-attribute-group>
                          </sc-padding>
                        </sc-bordered-tile>
                    </sc-flex-fitting-content>
                    </ng-container>
                    </sc-flex>
                  </sc-padding>
                </div>

                <div class="calculation-rules" *ngIf="mode === 'retail'" >

                    <sc-padding>
                        <sc-flex vertical stretchContent>
                            <ng-container *ngFor="let rule of articleType.calculationRules; let i = index">
                                <sc-content-spacer vertical *ngIf="i > 0"></sc-content-spacer>
                                <sc-flex >
                                    <sc-icon iconClass="fa-plus fa-2x" *ngIf="rule.method == 'ADD'"></sc-icon>
                                    <sc-icon iconClass="fa-minus fa-2x" *ngIf="rule.method == 'SUBTRACT'"></sc-icon>
                                    <sc-content-spacer></sc-content-spacer>
                                    <app-dictionary-entry-label [model]="rule.name"></app-dictionary-entry-label>
                                    <sc-content-spacer grow></sc-content-spacer>
                                    <mat-form-field appearance="fill" class="number-field">
                                        <mat-label>
                                          <sc-dictionary-label dictionaryKey="erp.entity.calculationrule.count"></sc-dictionary-label>
                                        </mat-label>
                                        <input matInput numberInput [scale]="2" [formControlName]="'rule_count_' + rule.id">
                                    </mat-form-field>
                                    <sc-content-spacer></sc-content-spacer>
                                    <sc-icon iconClass="fa-xmark fa-2x"></sc-icon>
                                    <sc-content-spacer></sc-content-spacer>
                                    <mat-form-field appearance="fill" class="number-field">
                                        <mat-label>
                                          <sc-dictionary-label dictionaryKey="erp.entity.calculationrule.factor"></sc-dictionary-label>
                                        </mat-label>
                                        <input matInput numberInput [scale]="3" [formControlName]="'rule_faktor_' + rule.id">
                                    </mat-form-field>
                                    <sc-content-spacer></sc-content-spacer>
                                    <sc-icon iconClass="fa-equals fa-2x"></sc-icon>
                                    <sc-content-spacer></sc-content-spacer>
                                    <div class="sum-column">
                                        {{ calculationResults.get(rule.id)  | numberFormat:priceScale}}
                                    </div>
                                </sc-flex>
                            </ng-container>
                        </sc-flex>
                    </sc-padding>
                </div>



                <div class="resulting-price">
                  <sc-padding>
                      <sc-flex stretchContent>
                        <div>
                          <sc-dictionary-label dictionaryKey="erp.ui.article-price-editor.label.resulting-price"></sc-dictionary-label>
                        </div>
                        <sc-content-spacer ></sc-content-spacer>
                        <mat-form-field appearance="fill" *ngIf="allowBasicPriceSelectionOption == true && useBasicPriceOptionSelected">
                          <mat-label>
                            <sc-dictionary-label dictionaryKey="erp.ui.article-price-editor.label.label.basicarticleprice.referenceDate"></sc-dictionary-label>
                          </mat-label>
                          <input matInput [matDatepicker]="picker4" formControlName="resultingprice_calculation_date">
                          <mat-datepicker-toggle matSuffix [for]="picker4"></mat-datepicker-toggle>
                          <mat-datepicker #picker4></mat-datepicker>
                        </mat-form-field>
                        <sc-content-spacer grow></sc-content-spacer>
                        <div>{{resultingPriceNet | numberFormat:priceScale}} €</div>
                      </sc-flex>
                  </sc-padding>
                </div>
            </sc-flex>
        </form>
    </div>

    <sc-actionbar>
        <sc-content-spacer grow></sc-content-spacer>
        <button mat-stroked-button (click)="onClose()">
          <sc-dictionary-label dictionaryKey="erp.ui.article-price-editor.action.cancel"></sc-dictionary-label>
        </button>
        <sc-content-spacer></sc-content-spacer>
        <button mat-flat-button (click)="onConfirm()" [disabled]="confirmDisabled">
          <sc-dictionary-label dictionaryKey="erp.ui.article-price-editor.action.confirm"></sc-dictionary-label>
        </button>
    </sc-actionbar>
</sc-flex>
